import { TypeAnimation } from "react-type-animation";

export const TypingComponent = ({ children }: { children: string }) => {
  return (
    <TypeAnimation
      cursor={false}
      sequence={[children]}
      wrapper="span"
      speed={71}
      key={children.length}
    />
  );
};
